import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

export default class Flash extends Component {
    render() {
        const { children, icon, inverse, fill, type, shadowed, testId, ...rest } = this.props;
        const iconComponent = icon ? <Icon icon={icon} /> : null;
        return (
            <div
                className={cl(
                    'flash',
                    `flash--${type}`,
                    { 'flash--iconed': iconComponent },
                    { 'flash--inverse': inverse },
                    { 'flash--fill': fill },
                    { 'flash--shadowed': shadowed && !inverse }
                )}
                data-testid={testId}
                {...rest}
            >
                {iconComponent}
                <span>{children}</span>
            </div>
        );
    }
}

Flash.defaultProps = {
    type: 'error',
    icon: '',
    inverse: false,
    fill: false,
    shadowed: false,
    testId: 'flash',
};

Flash.propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'tip', 'howto']),
    icon: PropTypes.string,
    inverse: PropTypes.bool,
    fill: PropTypes.bool,
    shadowed: PropTypes.bool,
    testId: PropTypes.string,
};
